import { render, staticRenderFns } from "./DepTable.vue?vue&type=template&id=06d20f52&scoped=true"
import script from "./DepTable.vue?vue&type=script&lang=js"
export * from "./DepTable.vue?vue&type=script&lang=js"
import style0 from "./DepTable.vue?vue&type=style&index=0&id=06d20f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d20f52",
  null
  
)

export default component.exports